import {Component, Prop, Vue} from "vue-property-decorator";
import {sort} from "~/lib/helpers";
import {Icon, icons} from "~/components/icon";
import {Columns} from "~/components/grid/columns";
import {Column} from "~/components/grid/column";
import {TextFilter} from "~/components/text-filter";
import XSelect from "~/components/forms/x-select";
import {isDefined} from "~/lib/helpers/guards";

// Change the order of keys to change the order of the genereted display
const knownCategories = {
  datasets: {label: "Données", icon: icons.multiSettings},
  maps: {label: "Cartes", icon: icons.multiSettings},
  analysis: {label: "Outils", icon: icons.multiSettings},
  files: {label: "Fichiers", icon: icons.multiSettings},
  users: {label: "Utilisateurs", icon: icons.multiSettings},
  admin: {label: "Administration", icon: icons.multiSettings},
  unknown: {label: "Sans catégorie", icon: icons.multiSettings},
};


@Component
export class ScopesMatrix extends Vue {

  @Prop({type: Array, required: true}) roles: any[];
  @Prop({type: Array, required: true}) scopes: any[];

  private scopesByCategories = null;

  private rolesFilter = null;
  private scopesFilter = "";

  get rolesList() {

    if (this.rolesFilter) {
      return [this.rolesFilter];
    }

    return sort(this.roles, (a, b) => {
      if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
      if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
      return 0;
    })
  }

  created() {
    this.scopesByCategories = categoriseScopes(this.scopes);
  }


  getScopeStatusForRole(role, scope) {
    return role.scopes.indexOf(scope.id) !== -1 ?
      <Icon class="scope-status scope-status--ok" icon={icons.check}/> :
      <Icon class="scope-status scope-status--ko" icon={icons.close}/>;
  }

  renderRolesCells(scope) {
    return this.rolesList.map(role => {
      return (
        <td>{this.getScopeStatusForRole(role, scope)}</td>
      );
    });
  }

  renderCategories() {

    return Object.keys(this.scopesByCategories).map(category => {

      let scopesList = this.scopesByCategories[category];

      if (this.scopesFilter.length) {
        let filter = this.scopesFilter.toLowerCase();
        scopesList = scopesList.filter(scope => scope.description.toLowerCase().includes(filter));
      }

      const output = [];

      // Returns early, no scope to show
      if( scopesList.length === 0 ){
        return output;
      }

      output.push(
        <tr class="no-border">
          <td class="sticky-col scopes-matrix_category">
            <div>
              <Icon icon={knownCategories[category].icon} />
              <span>{knownCategories[category].label}</span>
            </div>
          </td>
        </tr>
      );

      for (let scope of scopesList) {
        output.push(
          <tr>
            <td class="sticky-col">{scope.description}</td>
            {this.renderRolesCells(scope)}
          </tr>
        );
      }

      return output;
    });
  }

  renderTable() {

    const renderedCategories = this.renderCategories();

    if (this.scopes.length === 0 || renderedCategories.flat().length === 0) {
      return <p>Aucun droit trouvé</p>
    }

    return (
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
          <th class="sticky-col"/>
          {this.rolesList.map(role => <th>{role.label}</th>)}
          </thead>

          <tbody>
            {renderedCategories}
          </tbody>

        </table>
      </div>
    );

  }

  render() {
    return (
      <div class="scopes-matrix">

        <Columns class="list-options">
          <Column>
            <TextFilter
              v-model={this.scopesFilter}
              placeholder="Rechercher un droit"
            />
          </Column>
          <Column>
            <XSelect
              allowNull
              value={this.rolesFilter}
              data={this.roles}
              label={r => r.label}
              equality={(r, v) => r?.id === v?.id}
              onInput={r => this.rolesFilter = r}
            />
          </Column>
        </Columns>

        {this.renderTable()}
      </div>
    );
  }
}


/*********************************************
 * Private
 ********************************************/

function categoriseScopes(scopes) {

  // Transform knownCategories records into a hashmap of lists.
  const scopesByCat: { [key: string]: any } = Object.keys(knownCategories).reduce((acc, key) => {
    acc[key] = [];
    return acc;
  }, {});

  for (let scope of scopes) {

    let category = scope.key.split(":")[0];
    if (isDefined(category) && isValidCategory(category)) {
      addToCategory(scopesByCat, category, scope);
    } else {
      addToCategory(scopesByCat, "unknown", scope);
    }
  }

  // We sort each categorised list by order
  for (let list of Object.values(scopesByCat)) {
    list.sort((a, b) => {
      if (a.order > b.order) return 1;
      if (a.order < b.order) return -1;
      return 0;
    })
  }

  return scopesByCat;
}

function isValidCategory(category) {
  return knownCategories.hasOwnProperty(category);
}

function addToCategory(record, category, scope) {
  if (!record.hasOwnProperty(category)) {
    record[category] = [];
  }
  record[category].push(scope);
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-05ff668e/scopes-matrix.tsx" });